//libs
import React, { memo, useEffect, useState } from 'react';

//styles
import { Wrapper, Container } from './styles';
import { CarouselDots } from 'shared/styles/assets/icons/components/Dots';

//constants
import { INITIAL_END_VALUE, INITIAL_START_VALUE, INITIAL_TRANSLATE_VALUE } from './constants';

//helpers
import { getClassName, getBasicDotsValues } from './helpers';
export interface Props {
  totalCount: number;
  activeIndex: number;
  videoIndex?: number;
  width: number;
  className?: string;
}

function Dots({ totalCount, activeIndex, videoIndex, width, className }: Props) {
  const [dotsPosition, setDotsPosition] = useState({
    start: INITIAL_START_VALUE,
    end: INITIAL_END_VALUE,
    translate: INITIAL_TRANSLATE_VALUE,
  });
  //these are basic calculations for dots sliding.
  const { translateBy, dotDimensions, containerWidth } = getBasicDotsValues(width);

  useEffect(() => {
    if (activeIndex === 0) {
      setDotsPosition(() => ({
        start: INITIAL_START_VALUE,
        end: INITIAL_END_VALUE,
        translate: INITIAL_TRANSLATE_VALUE,
      }));
    } else if (totalCount - 1 !== activeIndex) {
      if (activeIndex <= dotsPosition.start) {
        setDotsPosition((prev) => ({
          start: prev.start - 1,
          end: prev.end - 1,
          translate: prev.translate + translateBy,
        }));
      }
      if (activeIndex >= dotsPosition.end - 1) {
        setDotsPosition((prev) => ({
          start: prev.start + 1,
          end: prev.end + 1,
          translate: prev.translate - translateBy,
        }));
      }
    }
  }, [translateBy, activeIndex, totalCount, dotsPosition.start, dotsPosition.end]);

  return (
    <Wrapper data-test="carousel-dots" className={className} containerWidth={containerWidth}>
      <Container position={dotsPosition.translate} className="dots">
        {Array(totalCount)
          .fill('_')
          .map((_, indx) => {
            let dotClassName = getClassName({
              indx,
              totalCount,
              activeIndex,
              start: dotsPosition.start,
              end: dotsPosition.end,
            });

            return (
              <CarouselDots
                key={`dots_${indx + 1}`}
                isActive={indx === activeIndex}
                className={dotClassName}
                isVideo={videoIndex === indx}
                size={dotDimensions}
              />
            );
          })}
      </Container>
    </Wrapper>
  );
}
export default memo(Dots);
